import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FaqListData, QAData, TitleInfo } from '../../../common/interfaces';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'vsf-faq-list',
  templateUrl: './faq-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqListComponent {
  @Input() faqList: FaqListData;
  @Input() linePadding: string;
  @Input() titleInfo: TitleInfo | null = null;

  showAll = false;
  qaList: QAData[] = [];
  defaultDisplayCount: number = 3;

  constructor(private logger: NGXLogger) {}

  ngOnInit() {
    this.defaultDisplayCount = this.faqList?.defaultDisplayCount || 3;
    this.qaList = this.faqList?.qaList.map(item => {
        return {
            question: item?.question,
            answer: item?.answer,
            open: false,
        };
    });
  }

  // Toggle the open state for an FAQ item.
  toggleFaq(faq: QAData): void {
    faq.open = !faq.open;
  }

  // Return either the full list or only a subset.
  getVisibleFaqs(): QAData[] {
    return this.showAll ? this.qaList : this.qaList.slice(0, this.defaultDisplayCount);
  }

  // Show all questions when the button is clicked.
  showAllQuestions(): void {
    this.showAll = true;
  }
}
